<script>
import Store from 'stores/overview/purchase/store';
import OverviewNav from './../overview/OverviewNav.vue';
import BackListing from './../overview/BackListing.vue';
import AnnotationsTab from 'vcomponents/pages/overview/AnnotationsTab.vue';
import DocumentEmail from 'vcomponents/documents/DocumentEmail.vue';
import DocumentSendEmail from 'vcomponents/documents/DocumentSendEmail.vue';
import DocumentStatusEditInPlace from 'vcomponents/documents/DocumentStatusEditInPlace/DocumentStatusEditInPlace.vue';
import DocumentTagWrapper from 'vcomponents/documents/DocumentTagWrapper/DocumentTagWrapper.vue';

export default {
    components: {
        OverviewNav,
        BackListing,
        AnnotationsTab,
        DocumentEmail,
        DocumentSendEmail,
        DocumentStatusEditInPlace,
        DocumentTagWrapper,
    },
    props: {
        doctype: {
            type: String,
            required: true,
        },
        docid: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        identity() {
            return {
                type: this.doctype,
                id: this.docid,
            };
        },
        splitter() {
            return new RegExp('\\?_f=purchases_' + this.doctype + 'Overview&id=(\\d+)');
        },
    },
    created() {
        this.$store.registerModule('purOverview', Store);
    },
};
</script>
